import { SlideMasterProps } from '@features/powerpoint';
import { titleSlideBackgroundWithGradient } from '../../images';

export const TITLE = 'SECTION_TITLE';

export const sectionTitleSlideMaster: SlideMasterProps = {
  title: TITLE,
  background: { path: titleSlideBackgroundWithGradient },
};
